export default "__VITE_ASSET__CPceEO7e__"